import { Button, Modal, Radio } from "antd";
import { useEffect, useState } from "react";
import CustomModel from "../../Utility/CustomModel";
import { toast } from "react-toastify";
import parse from "html-react-parser";
import {
  addReferenceTitle,
  referenceListing,
} from "../../Utility/referenceListing";
import { setRemoveDuplicate } from "../../reducer/slice";
import { useDispatch } from "react-redux";
export const PanelDuplicateRef = ({
  editor,
  visible,
  onClose,
  duplicates,
  setGenerateQuery,
  queryId,
}) => {
  const [refId, setRefId] = useState([]);
  const [selectedRefId, setSelectedRefId] = useState(null);
  const dispatch = useDispatch();
  function generateRandomId(existingIds, prefix = "") {
    let id;
    do {
      id = prefix + Math.random().toString(36).substr(2, 5);
    } while (existingIds.includes(id));
    return id;
  }

  function generateDuplicateMessage(refIds) {
    if (!Array.isArray(refIds) || refIds.length < 2) return "";

    // Extract just the numbers from the IDs
    const numbers = refIds
      .map((id) => parseInt(id.replace(/[^\d]/g, ""), 10))
      .sort((a, b) => a - b);

    if (numbers.length === 2) {
      return `References [${numbers[0]}] and [${numbers[1]}] seem to be the same. Please update the reference list as well as citation within the text.`;
    }

    const refs =
      numbers
        .slice(0, -1)
        .map((n) => `[${n}]`)
        .join(", ") + ` and [${numbers[numbers.length - 1]}]`;
    return `References ${refs} seem to be the same. Please update the reference list as well as citation within the text.`;
  }

  const handleGenerateQuery = () => {
    if (selectedRefId && refId.length) {
      const newId = generateRandomId(queryId); // your unique ID logic
      const refElement = editor.dom.select(`ref[id="${selectedRefId}"]`)[0];

      let generateQuery = {
        craetedBy: "Editor",
        queryid: newId,
        refId: selectedRefId,
        comments: [],
      };
      if (!refElement) {
        toast.warn("No <ref> found with id:", selectedRefId);
        return;
      }

      const refOutput = editor.dom.select("refoutput", refElement)[0];
      const hasQuery = refOutput && refOutput.querySelector("query") !== null;
      if (!refOutput) {
        console.warn(
          "No <refoutput> found inside <ref> with id:",
          selectedRefId
        );
        return;
      }
      if (hasQuery) {
        toast.warn("Query Already Generated");
        return;
      }

      const duplicateMsg = generateDuplicateMessage(refId);
      let queryComment = {
        comment: duplicateMsg,
        id: 0,
        name: "Editor",
        selectedIndex: "",
      };
      generateQuery.comments.push(queryComment);
      // Create new <query> element
      const queryTag = editor.dom.create(
        "query",
        {
          "data-query-id": newId,
          class: "query-wrapper", // Optional class
        },
        `<queryfirst data-edit='queryFirst' class='queryFirst'>Q.</queryfirst> ${duplicateMsg}`
      );
      queryTag.setAttribute("data-edit", "query");
      queryTag.setAttribute("contenteditable", "true");
      queryTag.setAttribute("data-lock", "true");

      // Append <query> to the end of <refoutput>
      refOutput.appendChild(queryTag);

      setGenerateQuery(generateQuery);
      toast.success("Query Generated");
      onClose();
    } else if (!duplicates.length) {
      toast.warn("No Duplicates Found");
    } else {
      toast.warn("Please Select Reference");
    }
  };

  const handleRemoveDuplicate = (id) => {
    if (selectedRefId && refId.length) {
      const refElement = editor.dom.select(`ref[id="${id}"]`)[0];
      if (refElement) {
        editor.dom.remove(refElement);
        referenceListing(editor);
        addReferenceTitle(editor);
        dispatch(setRemoveDuplicate({ show: true, id }));
        onClose();
        toast.success("Reference Deleted");
      } else {
        toast.warn("Error deleting Reference");
      }
    } else if (!duplicates.length) {
      toast.warn("No Duplicates Found");
    } else {
      toast.warn("Please Select Reference");
    }
  };

  const handleSelectRef = (e, item) => {
    const allIds = item.map((val) => val.id);
    setSelectedRefId(e.target.value);
    setRefId(allIds);
  };

  return (
    <div className="w-full flex flex-col justify-between min-h-full">
    <div className="w-full">
      <div className="border-b border-grey p-3 absolute top-0 bg-leftPanelbg inset-x-0 z-[10]">
        <h4 className="font-semibold text-primary text-[18px]">
          Duplicate References
        </h4>
      </div>
      {!duplicates?.length ? (
        <div className="my-8 duplicate-ref-modal mt-14 max-h-[calc(100%-68px)] overflow-auto">
          {duplicates.map((item, index) => (
            <Radio.Group
              className="flex flex-col mb-5 p-3 border border-grey rounded-[12px] gap-5  bg-white"
              key={index}
              value={selectedRefId}
              onChange={(e) => handleSelectRef(e, item)}
            >
              {item.map((ref, i) => {
                let Id = parseInt(ref.id.replace(/[^\d]/g, ""), 10);
                return (
                  <Radio className={`text-[15px] gap-[10px] ${item?.length-1!==i?"border-b border-grey pb-5":""}`} key={i} value={ref.id}>
                    Reference-{Id} : {parse(ref.displayText)}
                  </Radio>
                );
              })}
            </Radio.Group>
          ))}
        </div>
      ) : (
        <>
          <h2 className="text-[18px] text-center mt-20 font-semibold">
            No Duplicates Found
          </h2>
        </>
      )}
      </div>
      <div className="ml-auto w-full">
        <div className="flex pt-3 ml-auto justify-end gap-3">
         
          <button
            className=" px-1 py-1 text-[15px] bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
            onClick={() => handleGenerateQuery()}
          >
            {" "}
            Generate Query
          </button>
          <button
            className="px-1 py-1 text-[15px] bg-[#ff1f00d9] text-white rounded-[8px] hover:bg-[#fb290d] hover:shadow-services"
            onClick={() => handleRemoveDuplicate(selectedRefId)}
          >
            Remove Duplicate
          </button>
           <button
            className=" px-1 py-1 text-[15px] rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
            onClick={onClose}
          >
            {" "}
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
